import React from 'react'

export const Cube = ({ color, size = [1, 1, 1], position, rotation, opacity }) => {
	return (
		<mesh position={position} rotation={rotation} castShadow={!opacity || opacity > 0.7} receiveShadow>
			<boxGeometry args={size} />
			<meshStandardMaterial color={color} opacity={opacity} transparent={Boolean(opacity)} />
		</mesh>
	)
}
